import { render, staticRenderFns } from "./viewExpensesType.vue?vue&type=template&id=6152fd88&scoped=true&"
import script from "./viewExpensesType.vue?vue&type=script&lang=js&"
export * from "./viewExpensesType.vue?vue&type=script&lang=js&"
import style0 from "./viewExpensesType.vue?vue&type=style&index=0&id=6152fd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152fd88",
  null
  
)

export default component.exports